export default __webpack_public_path__ + "static/media/logoWithTextBlue.7c805995.svg";